import "core-js/modules/es.array.reverse.js";
var _class, _MapboxMapCatalogItem;
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable } from "mobx";
import MapboxImageryProvider from "terriajs-cesium/Source/Scene/MapboxImageryProvider";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import MapboxMapCatalogItemTraits from "../../../Traits/TraitsClasses/MapboxMapCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";

/**
 *  A raster catalog item representing a layer from the Mapbox server.
 */
let MapboxMapCatalogItem = (_class = (_MapboxMapCatalogItem = class MapboxMapCatalogItem extends CatalogMemberMixin(MappableMixin(CreateModel(MapboxMapCatalogItemTraits))) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "type", MapboxMapCatalogItem.type);
    makeObservable(this);
  }
  get imageryProvider() {
    var _this$maximumLevel;
    const mapId = this.mapId;
    const accessToken = this.accessToken;
    if (mapId === undefined || accessToken === undefined) {
      return;
    }
    const url = this.url === undefined ? undefined : proxyCatalogItemUrl(this, this.url);
    const imageryProvider = new MapboxImageryProvider({
      url,
      mapId,
      accessToken,
      credit: this.attribution,
      maximumLevel: (_this$maximumLevel = this.maximumLevel) !== null && _this$maximumLevel !== void 0 ? _this$maximumLevel : 25,
      minimumLevel: this.minimumLevel,
      format: this.format
    });
    return imageryProvider;
  }
  forceLoadMapItems() {
    return Promise.resolve();
  }
  get mapItems() {
    const imageryProvider = this.imageryProvider;
    if (imageryProvider === undefined) {
      return [];
    }
    const imageryPart = {
      imageryProvider,
      show: this.show,
      alpha: this.opacity,
      clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
    };
    return [imageryPart];
  }
}, _defineProperty(_MapboxMapCatalogItem, "type", "mapbox-map"), _MapboxMapCatalogItem), _applyDecoratedDescriptor(_class.prototype, "imageryProvider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageryProvider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _class);
export { MapboxMapCatalogItem as default };